/* eslint-disable */
import troop from './troop';
import troopMember from './troopMember';
import discuss from './discuss';
import discussMember from './discussMember';
import recent from './recent';
import QQFriend from './QQFriend';
import colleague from './colleague';
import customer from './customer';
import cloudPhoneBook from './cloudPhoneBook';
import groupChat from './groupChat';
import groupChatMember from './groupChatMember';
import confGroup from './confGroup';
import confGroupMember from './confGroupMember';
import customeBase from './customeBase';
import groupAssistant from './groupAssistant';
import companyWeChatOrg from './companyWeChatOrg';
import GQQFriend from './GQQFriend';
import Gtroop from './Gtroop';

export default {
    troop,
    QQFriend,
    colleague,
    troopMember,
    discussMember,
    discuss,
    recent,
    customer,
    cloudPhoneBook,
    groupChat,
    groupChatMember,
    confGroup,
    confGroupMember,
    customeBase,
    groupAssistant,
    companyWeChatOrg,
    GQQFriend,
    Gtroop
};
